import { ArrowLeft, Construction } from "lucide-react";
import { AppLink, StatusBadge } from "@league-command/ui";

interface PlaceholderRouteProps {
  title: string;
}

export const PlaceholderRoute = ({ title }: PlaceholderRouteProps) => (
  <section className="placeholder-route">
    <StatusBadge tone="pending">Roadmap module</StatusBadge>
    <Construction aria-hidden size={34} />
    <h1>{title}</h1>
    <p>
      This route is reserved in the League Command information architecture. The current
      bounded proof does not fake its authoritative behavior.
    </p>
    <AppLink href="/league">
      <ArrowLeft aria-hidden size={17} /> Return to Command Deck
    </AppLink>
  </section>
);
